import styled from 'styled-components';

const Row = styled.div`
  clear: both;

  &::after {
    content: '';
    clear: both;
    display: table;
  }
`;

export default Row;
